import { $myFetch } from "."
import { ITechField, ITechRawData } from "../../models/bo"

export const $getTechFamilies = () => {
  const myHeaders = new Headers()
  return $myFetch("technicaltree", {
    headers: myHeaders,
  })
}

export const $getFieldsByFamilyTech = (familyId: string) => {
  const myHeaders = new Headers()
  return $myFetch(`technicalcharacteristic/${familyId}`, {
    headers: myHeaders,
  })
    .then((res) => res.json())
    .then((res: ITechRawData[]) => res)
}
